import { AIModel } from 'common/types';
import { DanqingAxiosInstance } from './axiosInstances';

export interface AiModelParams extends AIModel {
  pageIndex?: number;
  pageSize?: number;
}

const danqing = {
  getAiModelList: (params: AiModelParams): ExtendAxioResponse<AIModel[]> => {
    return DanqingAxiosInstance.post(`/public/model/list`, params);
  },
  getAiWorkFlowlList: (params: AiModelParams): ExtendAxioResponse<AIModel[]> => {
    return DanqingAxiosInstance.post(`/public/workflow/list`, params);
  },
  updateModelVisible: (
    params: Pick<AIModel, 'businessId' | 'businessType'> & { projectCode: string },
  ): ExtendAxioResponse<AIModel[]> => {
    return DanqingAxiosInstance.post(`/public/update/visible`, params);
  },
  getAllCondition: (): ExtendAxioResponse<AIModel[]> => {
    return DanqingAxiosInstance.post(`/public/search/condition`, {});
  },
};

export default danqing;
